import './DoctorSection.css';

function ArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <line x1="5"  y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
}

function DoctorSection({ onOpenModal }) {
  return (
    <section className="doctor-section" id="about">

      {/* LEFT */}
      <div className="doc-img-side">
        <div className="doc-photo-wrap">
          <img src="/sunil_patel.jpeg" alt="Dr. Sunil Patel" className="doc-img" />
        </div>
        <div className="doc-name-badge">
          <h3>Dr. Sunil Patel</h3>
          <span>Certified Financial Fiduciary · 20+ Years Experience</span>
        </div>
      </div>

      {/* RIGHT */}
      <div className="doc-text-side">
        <span className="sec-pre rv">Meet Your Advisor</span>
        <span className="doc-quote-mark">"</span>

        <p className="doc-bio rv">
          <strong>Dr. Sunil Patel</strong> is a certified financial fiduciary who specializes in
          providing strategies and guidance for those who are seeking a better lifestyle in retirement.
        </p>

        <p className="doc-bio rv">
          There is no one "best place" to put your retirement money because each individual and couple
          has unique requirements, different tolerances for risk, and need their money at different times.{' '}
          <strong>Your unique circumstances must be taken into consideration</strong> if you seek to find
          the "most favorable place" for your retirement money.
        </p>

        <p className="doc-bio rv">
          We have helped individuals and couples, at all economic levels, to achieve their financial and
          long-term goals and enjoy retirement by working hard and smart, and being ready for them when needed.
        </p>

        <p className="doc-bio rv">
          We're very hopeful for an opportunity to{' '}
          <strong>discuss your retirement strategy</strong> so you can learn firsthand how we can be of benefit.
        </p>

        <div className="doc-cta-row rv">
          <a
            href="#"
            className="btn-g"
            onClick={(e) => { e.preventDefault(); onOpenModal(); }}
          >
            Book a Consultation <ArrowIcon />
          </a>
        </div>
      </div>
    </section>
  );
}

export default DoctorSection;
